import ListSelector, { IListSelectorOption } from '../../../../../../../components/molecules/listSelector/ListSelector'
import { ITypes, TYPES } from '../../../../../../../providers/bookAssistant/types'

export const RESERVATION_TYPE_OPTIONS: IListSelectorOption<ITypes[keyof ITypes]>[] = [
  { value: TYPES.DAY, label: 'Día' },
  { value: TYPES.TEN_DAYS, label: 'Bono 10 días' },
  { value: TYPES.MONTH, label: 'Mes' },
]

interface IProps {
  selectedType: string
  onSelect: (type: ITypes[keyof ITypes]) => void
}

const ReservationTypeSelector = ({ selectedType, onSelect }: IProps) => {
  return (
    <ListSelector
      options={RESERVATION_TYPE_OPTIONS}
      selectedValue={selectedType as ITypes[keyof ITypes]}
      onSelect={onSelect}
    />
  )
}

export default ReservationTypeSelector
